import { ICellEditorAngularComp } from '@ag-grid-community/angular';
import { GridApi, ICellEditorParams } from '@ag-grid-community/core';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  inject,
  ViewChild,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';

import { ActivitiesTabService } from '@features/inline-budget/be-activities-attributes-modal/activities-tab/services/activities-tab.services';

import {
  ExtendableDropdownOption,
  ExtendableOptionsDropdownComponent,
} from '@shared/components/extendable-options-dropdown/extendable-options-dropdown.component';
import { Option } from '@shared/types/components.type';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ExtendableOptionsDropdownComponent, ReactiveFormsModule],
  selector: 'aux-units-of-measure-dropdown',
  templateUrl: 'units-of-measure-dropdown.component.html',
})
export class UnitsOfMeasureDropdownComponent implements ICellEditorAngularComp {
  private activitiesTabService = inject(ActivitiesTabService);
  private changeDetectorRef = inject(ChangeDetectorRef);

  options = computed<ExtendableDropdownOption[]>(() => {
    return (
      this.activitiesTabService.unitsOfMeasure().map((unitOfMeasure) => ({
        id: unitOfMeasure.name,
        value: unitOfMeasure.name,
      })) || []
    );
  });

  @ViewChild(ExtendableOptionsDropdownComponent)
  dropdownComponent!: ExtendableOptionsDropdownComponent;
  gridApi!: GridApi;
  @ViewChild('ngSelect', { static: false }) ngSelect!: NgSelectComponent;
  params!: ICellEditorParams;
  unitsOfMeasureControl = new FormControl<null | string>(null);

  agInit(params: ICellEditorParams): void {
    this.unitsOfMeasureControl.setValue(params.value || null);
    this.gridApi = params.api;
    this.params = params;
    this.checkUnitOfMeasureListIsCorrect(params);
  }

  private checkUnitOfMeasureListIsCorrect(params: ICellEditorParams): void {
    const columnData = this.getColumnData(params.column.getColId(), params.api);

    if (columnData.length) {
      const notShownOptions = columnData.filter(
        (val) => !this.activitiesTabService.unitsOfMeasure().some((obj) => obj.name === val)
      );

      notShownOptions.forEach((option) => {
        if (option) {
          this.activitiesTabService.updateList(option);
        }
      });
    }
  }

  close(): void {
    this.dropdownComponent?.close();
    this.dropdownComponent?.detectChanges();
  }

  getColumnData(columnField: string, gridApi: GridApi): string[] {
    const columnData = new Set();

    gridApi.forEachNode((node) => {
      const option = node.data[columnField];

      if (option) {
        columnData.add(option);
      }
    });

    return Array.from(columnData) as string[];
  }

  getValue(): string {
    return this.unitsOfMeasureControl.value || '';
  }

  get initialSearchTerm(): string {
    if (typeof this.params?.eventKey === 'string') {
      return this.params.eventKey.length === 1 ? this.params.eventKey : '';
    }

    return '';
  }

  onAddOption(option: Option): void {
    this.activitiesTabService.updateList(option.value);
  }

  stopEditing(): void {
    this.gridApi.stopEditing();
    this.gridApi.setFocusedCell(this.params.rowIndex, this.params.column.getColId());
    this.changeDetectorRef.detectChanges();
  }
}
